<router-outlet><app-spinner /></router-outlet>
<app-image-viewer />
